import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const dealFlowPath = `${baseUrl}/dealflow`;

export const { useGet: useDealFlow, useGetAll: useAllDealFlow } =
  apiCrudBuilder(dealFlowPath, "DealFlow");
